import React from "react";

import { Typography } from "clearsense-ui/components";

import Cell from "./Cell";

const PredictedPositivesRow = ({ positives }) => (
  <tr>
    <td className="p-6 bg-green-100 border border-gray-300">
      <Typography className="text-right">Predicted Positives</Typography>
    </td>

    <Cell
      percent={positives.true.percent}
      count={positives.true.count}
      className="bg-green-300"
    >
      <Typography>True Positives</Typography>
    </Cell>

    <Cell
      percent={positives.false.percent}
      count={positives.false.count}
      className="bg-red-200"
    >
      <Typography>False Positives</Typography>
    </Cell>

    <Cell
      percent={positives.predicted.percent}
      count={positives.predicted.count}
    >
      <Typography type="semibold" className="-mt-1 -mb-1 text-lg">
        Predicted Positives
      </Typography>
    </Cell>
  </tr>
);

export default PredictedPositivesRow;
